import Body from '../../components/Body';
import React from 'react';
import GeneratedSingleStory from '../../components/GeneratedSingleStory';
import { useParams } from 'react-router-dom';
import Footer from '../../components/Footer';

export default function ViewSingleStory() {
  const { storyuuid } = useParams();
  return (
    <Body>
      <GeneratedSingleStory storyuuid={storyuuid} />
    </Body>
  );
}